module.exports = __webpack_public_path__ + "img/创建引脚.20d8c4f8.svg";